<template>
    <div class="col-12 mb-4">
      <div v-if="subscriptionId == '' && subloading == false">
        <div class="row">
          <div class="col-12">
            <div class="alert alert-danger" style="margin-top: 10px;">
              Pricing is not assigned to this Account. Please select pricing from Affiliate Tab.
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="accountExpireDate == '' && subloading == false">
        <div class="row">
          <div class="col-12">
            <div class="bold text-center mb-2" style="color: #E4A11B;" v-if="orderId != '' && orderPaymentMethod == 'check'">Payment is pending for this account. Please click Billing button to complete the payment.</div>
            <div class="bold text-center mb-2" style="color: #E4A11B;" v-else-if="orderId != ''">Payment is pending for this account.</div>
            <div class="bold text-center mb-2" style="color: #E4A11B;" v-else>This account didn’t purchase any subscription. Please subscribe.</div>
      <b-alert
        :show="dismissAuthCountDown"
        dismissible
        variant="success"
        @dismissed="dismissAuthCountDown=0"
        @dismiss-count-down="countDownAuthChanged"
        >
        {{ success_auth_message }}
      </b-alert>
      <b-alert
        :show="dismissCountWarningDown"
        dismissible
        variant="danger"
        @dismissed="dismissCountWarningDown=0"
        @dismiss-count-down="countDownWarningChanged"
        >
        {{ warning_message }}
      </b-alert>

      <div v-if="(unitType == 'Seat')">

      <div class="search-padd">
        <div class="col-12 override-padding">
          <div class="crm_admin_heading nafield_1 pl-2">Billing Frequency</div>
          <div class="crm_admin_heading nafield_2 pl-2">Bundle</div>
          <div class="crm_admin_heading nafield_3 pl-2">Additional Mentees</div>
          <div class="crm_admin_heading nafield_4 pl-2">Bundle Rate</div>
          <div class="crm_admin_heading nafield_8 pl-2">Override Price</div>
          <div class="crm_admin_heading nafield_5 pl-2">Mentee Rate</div>
          <div class="crm_admin_heading nafield_6 pl-2">Total Price</div>
          <div class="crm_admin_heading nafield_7 text-center">&nbsp;</div>
        </div>
      </div>



      <div class="search-padd">
        <div class="col-12 override-padding order_items" style="float: left;padding-bottom: 10px !important;">
          <div class="nafield_1 pl-2 pt-2">
            <b-form-select class="custom-select billingInput" v-model="frequency" :options="frequencyoptions"
            v-validate="'required'" :disabled="reviewFlag == 1" v-on:change="billingModeChangeNewAccount($event)"
            name="frequency"
            ></b-form-select>
          </div>
          <div class="nafield_2 pl-2 pt-2">
            <b-form-select class="custom-select billingInput" v-model="bundle" :options="bundleoptions"
            v-validate="'required'" :disabled="reviewFlag == 1" v-on:change="frequencyChangeNewAccount()"
            name="frequency"
            ></b-form-select>
          </div>
          <div class="nafield_3 pl-2 pt-2" v-if="unlimited == true">
            <b-form-select class="col-7 custom-select billingInput" disabled="true" v-model="additionalSeatQty" :options="seat_qty_options"
             v-on:change="getAdditionalPriceforNewAccountSubscription()"
            name="additionalSeatQty"
            ></b-form-select>
            </div>
          <div class="nafield_3 pl-2 pt-2" v-else>
            <b-form-select class="col-7 custom-select billingInput" v-model="additionalSeatQty" :options="seat_qty_options"
             v-on:change="getAdditionalPriceforNewAccountSubscription()"
            name="additionalSeatQty"
            ></b-form-select>
            </div>
          <div class="nafield_4 pl-2 pt-2">
            $<input type="text" class="po_input col-12"  v-model="bundlePrice" name="bundlePrice" disabled="true" style="line-height: 27px; width: 91% !important;">
          </div>
          <div class="nafield_8 pl-2 pt-2">
            $<input type="text" class="po_input col-12" v-on:blur="overridePriceSeatSubTotal()"  v-model="overridePrice" name="bundlePrice" style="line-height: 27px; width: 91% !important;">
            <div v-if="isNumericOnlyErrorMsg" class="margin-bottom-5 validate-warning-msg">Override price should be numeric</div>                
          </div>
          <div class="nafield_5 pl-2 pt-2">
            $<input type="text" class="po_input col-12"  v-model="totalAdditionalPrice" name="totalAdditionalPrice" disabled="true" style="line-height: 27px; width: 91% !important;">
            </div>
          <div class="nafield_6 pl-2  pt-2" style="padding-top: 15px !important;">
            ${{ totalAmount }}
          </div>
          <div class="field_7 text-center pt-2">
            <button type="submit" class="btn btn-md ma-blue-btn" @click="onBillingOpen(totalAmount)">Billing</button>
          </div>
        </div>
      </div>



      </div>
            
            <div v-if="(unitType == 'License')">

            <div class="search-padd">
              <div class="col-12 override-padding">
                <div class="crm_admin_heading nafield_l_1 pl-2  text-center">Unit Type</div>
                <div class="crm_admin_heading nafield_l_2 pl-2">Unit</div>
                <div class="crm_admin_heading nafield_l_3 pl-2">Price</div>
                <div class="crm_admin_heading nafield_l_6 pl-2">Override Price</div>
                <div class="crm_admin_heading nafield_l_4 pl-2">Total Price</div>
                <div class="crm_admin_heading nafield_l_5 text-center">Subscription</div>
              </div>
            </div>


            <div class="search-padd">
              <div class="col-12 override-padding order_items" style="float: left;padding-bottom: 10px !important;">
                <div class="nafield_l_1 pl-2 pt-2 text-center">
                  {{ unitType }}
                </div>
                <div class="nafield_l_2 pl-2 pt-2">
                  <b-form-select class="col-7 custom-select billingInput" v-model="unit" :options="qty_options"
                  v-validate="'required'" v-on:change="getLicensePriceforSubscriptionNewAccount()"
                  name="unit"
                  ></b-form-select>
                  </div>
                <div class="nafield_l_3 pl-2 pt-2">
                  $<input type="text" class="po_input col-12"  v-model="subscriptionPrice" v-validate="'required|numeric'" name="subscriptionPrice" disabled="true" style="line-height: 27px; width: 85% !important;">
                </div>
                <div class="nafield_l_6 pl-2 pt-2">
                  $<input type="text" class="po_input col-8"  v-on:blur="overridePriceSubTotal()" v-model="overrideSubscriptionPrice" name="bundlePrice" style="line-height: 27px; width: 91% !important;">
                  <div v-if="isNumericOnlyErrorMsg" class="margin-bottom-5 validate-warning-msg">Override price should be numeric</div>                
                </div>
                <div class="nafield_l_4 pl-2  pt-2" style="padding-top: 15px !important;">
                  ${{ subscriptionTotal }}
                </div>
                <div class="nafield_l_5 text-center pt-2">
                  <button type="submit" class="btn btn-md ma-blue-btn" @click="onBillingOpen(subscriptionTotal)"">Billing</button>
                </div>
              </div>
            </div>


            <div style="clear: both;" class="mb-4"></div>



            </div>



          </div>
        </div>
      </div>






      <div v-show="subloading" class="loading_show"><div class="spinner-border text-danger"></div></div>



      <div v-if="(accountExpireDate != '')">

      <div class="row">
        <div class="col-7">
          &nbsp;
        </div>
        <div class="col-5 text-right">
          <div class="col-12 p-0" v-if="unlimited == true">
            Unlimited Mentees
          </div>
          <div class="col-12 p-0" v-else>
            {{ usedLicense }}/{{ totalLicenseWithoutRenew }} Mentee {{ unitType }}s Used
          </div>
        </div>
      </div>

      <b-alert
        :show="dismissAuthCountDown"
        dismissible
        variant="success"
        @dismissed="dismissAuthCountDown=0"
        @dismiss-count-down="countDownAuthChanged"
        >
        {{ success_auth_message }}
      </b-alert>
      <b-alert
        :show="dismissCountWarningDown"
        dismissible
        variant="danger"
        @dismissed="dismissCountWarningDown=0"
        @dismiss-count-down="countDownWarningChanged"
        >
        {{ warning_message }}
      </b-alert>


      <div v-if="(unitType == 'License')">

      <div class="search-padd">
        <div class="col-12 override-padding">
          <div class="crm_admin_heading field_l_1 pl-2  text-center">Unit Type</div>
          <div class="crm_admin_heading field_l_2 pl-2">Unit</div>
          <div class="crm_admin_heading field_l_3 pl-2">Price</div>
          <div class="crm_admin_heading field_l_4 pl-2">Total Price</div>
          <div class="crm_admin_heading field_l_5 text-center">Subscription</div>
        </div>
      </div>


      <div class="search-padd">
        <div class="col-12 override-padding order_items" style="float: left;padding-bottom: 10px !important;">
          <div class="field_l_1 pl-2 pt-2 text-center">
            {{ unitType }}
          </div>
          <div class="field_l_2 pl-2 pt-2">
            <b-form-select class="col-7 custom-select billingInput" v-model="unit" :options="qty_options"
            v-validate="'required'" v-on:change="getLicensePriceforSubscription()"
            name="unit"
            ></b-form-select>
            </div>
          <div class="field_l_3 pl-2 pt-2">
            $<input type="text" class="po_input col-12"  v-model="subscriptionPrice" v-validate="'required|numeric'" name="subscriptionPrice" disabled="true" style="line-height: 27px; width: 85% !important;">
          </div>
          <div class="field_l_4 pl-2  pt-2" style="padding-top: 15px !important;">
            ${{ subscriptionTotal }}
          </div>
          <div class="field_l_5 text-center pt-2">
            <button type="submit" class="btn btn-md ma-blue-btn" @click="onLicenseSubmit()">Update</button>
            <br /> <button v-if="isDeveloperAdmin" type="submit" class="mt-2 btn btn-md ma-blue-btn" @click="onCheckPaymentUpdateOpen(subscriptionTotal)">Update Check</button>
          </div>
        </div>
      </div>


      <div style="clear: both;" class="mb-4"></div>

      </div>

      <div v-if="(unitType == 'Seat')">

      <div class="search-padd">
        <div class="col-12 override-padding">
          <div class="crm_admin_heading field_1 pl-2">Billing Frequency</div>
          <div class="crm_admin_heading field_2 pl-2">Bundle</div>
          <div class="crm_admin_heading field_3 pl-2">Add Mentees</div>
          <div class="crm_admin_heading field_4 pl-2">Bundle Rate</div>
          <div class="crm_admin_heading field_5 pl-2">Mentee Rate</div>
          <div class="crm_admin_heading field_6 pl-2" v-if="frequency == 'monthly'">Monthly Price</div>
          <div class="crm_admin_heading field_6 pl-2" v-else>Annual Price</div>
          <div class="crm_admin_heading field_7 text-center">Subscription</div>
        </div>
      </div>


      <div class="search-padd">
        <div class="col-12 override-padding order_items" style="float: left;padding-bottom: 10px !important;">
          <div class="field_1 pl-2 pt-2">
            <b-form-select class="custom-select billingInput" v-model="frequency" :options="frequencyoptions"
            v-validate="'required'" :disabled="reviewFlag == 1" v-on:change="billingModeChange($event)"
            name="frequency"
            ></b-form-select>
          </div>
          <div class="field_2 pl-2 pt-2">
            <b-form-select class="custom-select billingInput" v-model="bundle" :options="bundleoptions"
            v-validate="'required'" :disabled="reviewFlag == 1" v-on:change="frequencyChange()"
            name="frequency"
            ></b-form-select>
          </div>
          <div class="field_3 pl-2 pt-2" v-if="unlimited == true">
            <b-form-select class="col-7 custom-select billingInput" v-model="additionalSeatQty" :options="seat_qty_options"
             :disabled="disableAddSeat == true" disabled="true" v-on:change="getAdditionalPriceforSubscription()"
            name="additionalSeatQty"
            ></b-form-select>
            </div>
          <div class="field_3 pl-2 pt-2" v-else>
            <b-form-select class="col-7 custom-select billingInput" v-model="additionalSeatQty" :options="seat_qty_options"
             :disabled="disableAddSeat == true" v-on:change="getAdditionalPriceforSubscription()"
            name="additionalSeatQty"
            ></b-form-select>
            </div>
          <div class="field_4 pl-2 pt-2">
            $<input type="text" class="po_input col-12"  v-model="bundlePrice" v-validate="'required|numeric'" name="bundlePrice" disabled="true" style="line-height: 27px; width: 91% !important;">
          </div>
          <div class="field_5 pl-2 pt-2">
            $<input type="text" class="po_input col-12"  v-model="totalAdditionalPrice" v-validate="'required|numeric'" name="totalAdditionalPrice" disabled="true" style="line-height: 27px; width: 91% !important;">
            </div>
          <div class="field_6 pl-2  pt-2" style="padding-top: 15px !important;" v-if="refundFlag == 1">
            ${{ totalAmount }} (Refund Amount)
          </div>
          <div class="field_6 pl-2  pt-2" style="padding-top: 15px !important;" v-else>
            ${{ totalAmount }}
          </div>
          <div class="field_7 text-center pt-2">
            <button type="submit" class="btn btn-md ma-blue-btn" @click="onSubmit()">Update</button>
            <button v-if="isDeveloperAdmin" type="submit" class="mt-2 btn btn-md ma-blue-btn" @click="onCheckPaymentUpdateOpen(totalAmount)">Update Check</button>
          </div>
        </div>
      </div>

      <div class="row" v-if="reviewFlag == 1">
        <div class="col-12 pt-3">
          <i>Last monthly billing transaction is pending, so billing frequency and bundle field is disabled. </i>
        </div>
      </div>


      <div style="clear: both;" class="mb-4"></div>

      </div>

      <div v-if="(accountExpireDate != '')">

      <div class="search-padd">
        <div class="col-12 override-padding">
          <div class="crm_admin_heading pfield_1 pl-2">Payment Method</div>
          <div class="crm_admin_heading pfield_2 pl-2">Billing Information</div>
          <div class="crm_admin_heading pfield_3 pl-2">&nbsp;</div>
          <div class="crm_admin_heading pfield_4 pl-2">&nbsp;</div>
          <div class="crm_admin_heading pfield_5 pl-2">&nbsp;</div>
          <div class="crm_admin_heading pfield_6 pl-2">&nbsp;</div>
          <div class="crm_admin_heading pfield_7 text-center  pl-2">Auto-Renew</div>
          <div class="crm_admin_heading pfield_8 text-center">Subscription</div>
        </div>
      </div>



      <div class="search-padd">
        <div class="col-12 override-padding order_items" style="float: left;padding-bottom: 10px !important;">
          <div class="pfield_1 pl-2 pt-2">
            <b-form-select class="custom-select billingInput" v-model="payment_method_id" :options="cardOptions"
            v-on:change="paymentDetails()"
            name="payment_method_id"
            ></b-form-select>
          </div>
          <div class="pfield_2 pl-2 pt-2">
            <input type="text" class="po_input col-12"  v-model="address" name="address" style="line-height: 27px;">
          </div>
          <div class="pfield_3 pl-2 pt-2">
            <input type="text" class="po_input col-12"  v-model="city"  name="city" style="line-height: 27px;">
          </div>
          <div class="pfield_4 pl-2 pt-2">
            <b-form-select class="custom-select billingInput" v-model="state" :options="state_options"
            name="state"
            ></b-form-select>
          </div>
          <div class="pfield_5 pl-2 pt-2">
            <input type="text" class="po_input col-12"  v-model="zip"  name="zip" style="line-height: 27px;">
          </div>
          <div class="pfield_6 pl-2  pt-2">
            <b-form-select class="custom-select billingInput" v-model="country" :options="country_options"
            
            name="country"
            ></b-form-select>
          </div>
          <div class="pfield_7 text-center" style="margin-top: 12px !important;">
            <div class="chkboxwrapper">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  id="autoRenew"
                  name="autoRenew"
                  ref="autoRenew"
                  v-model="autoRenew"
                  :checked="autoRenew" class="custom-control-input"
                  :value="1">
                <label class="custom-control-label" for="autoRenew" ></label>
              </div>
            </div>

          </div>
          <div class="pfield_8 text-center pt-2">
            <button type="submit" class="btn btn-md ma-blue-btn" @click="onSubmitPaymentDetails()">Update</button>
          </div>
        </div>
      </div>

      </div>


      <div style="clear: both;" class="mb-3"></div>

      <div v-if="(unitType == 'Seat' || unitType == 'License')">

      <div class="col-12 p-0 heading mb-2">Subscription Forecast</div>

      <div class="search-padd">
        <div class="col-12 override-padding">
          <div class="crm_admin_heading admin_h_1 text-align-center" v-if="frequency == 'monthly'">Remaining</div>
          <div class="crm_admin_heading admin_h_1 text-align-center" v-else># of Purchase</div>
          <div class="crm_admin_heading admin_h_2 text-align-center">Total Subscription</div>
          <div class="crm_admin_heading admin_h_3 text-align-center">Total Processed</div>
          <div class="crm_admin_heading admin_h_4 text-align-center">Total Due</div>
          <div class="crm_admin_heading admin_h_5 text-align-center">Auto-Renew</div>
          <div class="crm_admin_heading admin_h_6 text-align-center">Avg. &#36;</div>
          <div class="crm_admin_heading admin_h_8 text-align-center">Onboarding Date</div>
          <div class="crm_admin_heading admin_h_7 text-align-center">Subscription Renewal</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div class="order_items" v-if="orderItems.length > 0">
          <div class="crm_admin_field_lists admin_h_1 text-align-center" v-if="frequency == 'monthly'">
              {{ totalOrders.noOfRemaining }}
          </div>
          <div class="crm_admin_field_lists admin_h_1 text-align-center" v-else>
              {{ totalOrders.noOfPurchase }}
          </div>
          <div class="crm_admin_field_lists admin_h_2 text-align-center">
              &#36;{{ totalOrders.totalOrderAmount }}
          </div>
          <div class="crm_admin_field_lists admin_h_3 text-align-center">
              &#36;{{ totalOrders.totalProcessedAmount }}
          </div>
          <div class="crm_admin_field_lists admin_h_4 text-align-center">
              &#36;{{ totalOrders.totalDue }}
          </div>
          <div class="crm_admin_field_lists admin_h_5 text-align-center">
              {{ totalOrders.autorenew }}
          </div>
          <div class="crm_admin_field_lists admin_h_6 text-align-center">
              &#36;{{ totalOrders.avgAmount }}
          </div>
          <div class="crm_admin_field_lists admin_h_8 text-align-center">
              {{ totalOrders.accountOnBoardingDate }}
              <a class="" v-if="totalOrders.accountOnBoardingDateFlag == 0"><i class="fa fa-pencil" aria-hidden="true" style="color: #00ACEE; cursor: pointer;" @click="openBoardingDateModal(totalOrders.accountOnBoardingDate)"></i></a>
          </div>
          <div class="crm_admin_field_lists admin_h_7 text-align-center">
              {{ totalOrders.accountExpireDate }} 
              <a class="" v-if="type == 'yearly' && unitType == 'Seat'"><i class="fa fa-pencil" aria-hidden="true" style="color: #00ACEE; cursor: pointer;" @click="openRenewalDateModal(totalOrders.accountExpireDate)"></i></a>
          </div>
          <div style="clear: both;"></div>
        </div>
        <div class="col-12 override-padding" v-if="orderItems.length == 0">
          No orders found
        </div>

        </div>

        <div v-if="frequency == 'monthly' && unitType == 'Seat'">
        <div class="col-12 p-0 mt-3 heading">Purchase History</div>

        <div class="col-12 override-padding mt-2">
          <div class="crm_admin_heading orders_heading_1 text-align-center">Status</div>
          <div class="crm_admin_heading orders_heading_9 text-align-left">Payment Method</div>
          <div class="crm_admin_heading orders_heading_2 text-align-left">Invoice #</div>
          <div class="crm_admin_heading orders_heading_3 text-align-left">Subscription</div>
          <div class="crm_admin_heading orders_heading_4 text-align-left">Billing Schedule</div>
          <div class="crm_admin_heading orders_heading_5 text-align-center">Total Amount</div>
          <div class="crm_admin_heading orders_heading_6 text-align-center">Invoice Date</div>
          <div class="crm_admin_heading orders_heading_7 text-align-center">Due Date</div>
          <div class="crm_admin_heading orders_heading_8 text-align-left">Status</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div class="purchashed_items" v-if="orderItems.length > 0">
          <div v-for="(item, pindex) in orderItems" class="purchase_items">
            <div class="crm_admin_field_lists orders_heading_1 text-align-center">
              <i :class="getStatusIcon(item.orderStatus)"></i>
            </div>
            <div class="crm_admin_field_lists orders_heading_9 text-align-left" v-if="item.paymentMethod == 'check'">
                Check
            </div>
            <div class="crm_admin_field_lists orders_heading_9 text-align-left" v-else>
                Credit card
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left" v-if="item.isMonthlyBilling == 1">
                <a href="javascript:void(0);" class="invoice_link" @click="getMonthlyInvoicePdf(item)">{{ item.invoiceNo }}</a>
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left" v-else>
                <a href="javascript:void(0);" class="invoice_link" @click="getInvoicePdf(item)">{{ item.invoiceNo }}</a>
            </div>
            <div class="crm_admin_field_lists orders_heading_3 text-align-left">
              {{ item.subscription }}
            </div>
            <div class="crm_admin_field_lists orders_heading_4 text-align-left">
              {{ item.schedule }}
            </div>
            <div class="crm_admin_field_lists orders_heading_5 text-align-center">
              &#36;{{ item.totalAmount }}
            </div>
            <div class="crm_admin_field_lists orders_heading_6 text-align-center">
              {{ item.date }}
            </div>
            <div class="crm_admin_field_lists orders_heading_7 text-align-center">
              {{ item.dueDate }}
            </div>
            <div class="crm_admin_field_lists orders_heading_8 text-align-left text-break" v-if="!item.checkReceivedFlag && item.paymentMethod == 'check'">
              {{ getPaymentStatus(item.orderStatus) }} 
            </div>
            <div class="crm_admin_field_lists orders_heading_8 text-align-left text-break" v-else>
              {{ getPaymentStatus(item.orderStatus) }} 
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="col-12 override-padding" v-if="orderItems.length == 0">
          No orders found
        </div>
        </div>

        <div v-if="frequency == 'yearly' && unitType == 'Seat'">
        <div class="col-12 p-0 mt-3 heading">Purchase History</div>

        <div class="col-12 override-padding mt-2">
          <div class="crm_admin_heading orders_heading_1 text-align-center">Status</div>
          <div class="crm_admin_heading orders_heading_9_1 text-align-left">Payment Method</div>
          <div class="crm_admin_heading orders_heading_2 text-align-left">Invoice #</div>
          <div class="crm_admin_heading orders_heading_3_1 text-align-left">Subscription</div>
          <div class="crm_admin_heading orders_heading_5_1 text-align-center">Total Amount</div>
          <div class="crm_admin_heading orders_heading_6_1 text-align-center">Invoice Date</div>
          <div class="crm_admin_heading orders_heading_8 text-align-left">Status</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div class="purchashed_items" v-if="orderItems.length > 0">
          <div v-for="(item, pindex) in orderItems" class="purchase_items">
            <div class="crm_admin_field_lists orders_heading_1 text-align-center">
              <i :class="getStatusIcon(item.orderStatus)"></i>
            </div>
            <div class="crm_admin_field_lists orders_heading_9_1 text-align-left" v-if="item.paymentMethod == 'check'">
                Check
            </div>
            <div class="crm_admin_field_lists orders_heading_9_1 text-align-left" v-else>
                Credit card
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left" v-if="item.isMonthlyBilling == 1">
                <a href="javascript:void(0);" class="invoice_link" @click="getMonthlyInvoicePdf(item)">{{ item.invoiceNo }}</a>
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left" v-else>
                <a href="javascript:void(0);" class="invoice_link" @click="getInvoicePdf(item)">{{ item.invoiceNo }}</a>
            </div>
            <div class="crm_admin_field_lists orders_heading_3_1 text-align-left">
              {{ item.subscription }}
            </div>
            <div class="crm_admin_field_lists orders_heading_5_1 text-align-center">
              &#36;{{ item.totalAmount }}
            </div>
            <div class="crm_admin_field_lists orders_heading_6_1 text-align-center">
              {{ item.date }}
            </div>
            <div class="crm_admin_field_lists orders_heading_8 text-align-left text-break" v-if="!item.checkReceivedFlag && item.paymentMethod == 'check'">
              {{ getPaymentStatus(item.orderStatus) }} 
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left text-break" v-else>
              {{ getPaymentStatus(item.orderStatus) }} <span class="badge badge-info text-uppercase" style="background-color: #FFA500;" v-if="item.refundFlag == 1">Refund</span>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="col-12 override-padding" v-if="orderItems.length == 0">
          No orders found
        </div>
        </div>


        <div v-if="unitType == 'License'">
        <div class="col-12 p-0 mt-3 heading">Purchase History</div>

        <div class="col-12 override-padding mt-2">
          <div class="crm_admin_heading orders_heading_1 text-align-center">Status</div>
          <div class="crm_admin_heading orders_heading_9_1 text-align-left">Payment Method</div>
          <div class="crm_admin_heading orders_heading_2 text-align-left">Invoice #</div>
          <div class="crm_admin_heading orders_heading_3_1 text-align-left">Purchase</div>
          <div class="crm_admin_heading orders_heading_5_1 text-align-center">Total Amount</div>
          <div class="crm_admin_heading orders_heading_6_1 text-align-center">Invoice Date</div>
          <div class="crm_admin_heading orders_heading_8 text-align-left">Status</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div class="purchashed_items" v-if="orderItems.length > 0">
          <div v-for="(item, pindex) in orderItems" class="purchase_items">
            <div class="crm_admin_field_lists orders_heading_1 text-align-center">
              <i :class="getStatusIcon(item.orderStatus)"></i>
            </div>
            <div class="crm_admin_field_lists orders_heading_9_1 text-align-left" v-if="item.paymentMethod == 'check'">
                Check
            </div>
            <div class="crm_admin_field_lists orders_heading_9_1 text-align-left" v-else>
                Credit card
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left" v-if="item.isMonthlyBilling == 1">
                <a href="javascript:void(0);" class="invoice_link" @click="getMonthlyInvoicePdf(item)">{{ item.invoiceNo }}</a>
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left" v-else>
                <a href="javascript:void(0);" class="invoice_link" @click="getInvoicePdf(item)">{{ item.invoiceNo }}</a>
            </div>
            <div class="crm_admin_field_lists orders_heading_3_1 text-align-left" v-if="item.noOfUnits == 1">
              {{ item.noOfUnits }} License
            </div>
            <div class="crm_admin_field_lists orders_heading_3_1 text-align-left" v-else>
              {{ item.noOfUnits }} Licenses
            </div>
            <div class="crm_admin_field_lists orders_heading_5_1 text-align-center">
              &#36;{{ item.totalAmount }}
            </div>
            <div class="crm_admin_field_lists orders_heading_6_1 text-align-center">
              {{ item.date }}
            </div>
            <div class="crm_admin_field_lists orders_heading_8 text-align-left text-break" v-if="!item.checkReceivedFlag && item.paymentMethod == 'check'">
              {{ getPaymentStatus(item.orderStatus) }} 
            </div>
            <div class="crm_admin_field_lists orders_heading_2 text-align-left text-break" v-else>
              {{ getPaymentStatus(item.orderStatus) }} 
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="col-12 override-padding" v-if="orderItems.length == 0">
          No orders found
        </div>
        </div>



        <div style="clear: both;" class="margin-bottom-10"></div>
      </div>

      </div>


        <RenewalDateChange
          :isModalVisible="isRenewDateChangeModalVisible"
          :accountId="accountId"
          ref="RenewDateChangeModal"
          @close="isRenewDateChangeModalVisible=false">
        </RenewalDateChange>

        <BoardingDateChange
          :isModalVisible="isBoardingDateChangeModalVisible"
          :accountId="accountId"
          ref="BoardingDateChangeModal"
          @close="isBoardingDateChangeModalVisible=false">
        </BoardingDateChange>

        <BillingModal :isModalVisible="isBillingModalVisible"  @close="isBillingModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Billing</div>
          <div slot="body" v-if="isBillingModalVisible == true">


            <div class="row pay_detail_row">
              <div class="col-md-12" id="pay_detail_row">
                <div class="card card_info">
                  <div class="col" style="padding-left: 7px;">
                  <div class="form-group row">
                    <label for="check_no" class="col-sm-5 col-form-label">Total Amount:</label>
                    <div class="col-sm-7">
                        $<input type="text" class="form-control billingInput" id="total_display_amount" v-model="total_display_amount" name="total_display_amount" style="width: 202px; display: inline-block;" disabled="true">
                    </div>
                  </div>
                  </div>
                
                  <div class="card-header purchasing_header">
                    <div class="card-title purchase_title">Payment Method</div>
                  </div>
                  <div class="card-body purchasing_body" id="billing_form_cc">
                    <form id="card_form" class="mt-0" autocomplete="off">
                      <div class="row">
                        <div class="col-sm-12 col-md-12 pr-0">
                          <div class="radio">
                            <label class="radio_input">
                              <input type="radio"  value="credit_card" v-validate="'required'" v-model="paymentMethod" name="payment_method" v-on:click="choosePaymentMode">&nbsp;Credit Cards (Process Online)
                            </label>
                            <div id="card_info" class="payment_mode_opt" style="display: block;"  v-if="isCheckPanel == true">
                            </div>
                            </div>
                          </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12  pr-0">
                          <div class="radio">
                            <label class="radio_input"><input type="radio" name="payment_method" v-on:click="choosePaymentMode" value="check" v-model="paymentMethod">&nbsp;Check (Mail In)</label>
                            <div v-if="verrors.firstByRule('payment_method', 'required')" class="margin-bottom-5 validate-warning-msg">You must choose a payment method</div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div id="check_info" class="col" style="padding-left: 7px; display: block;" v-if="isCreditPanel == true">
                    <div class="form-group row">
                      <label for="is_check_received" class="col-sm-5 col-form-label">Check Received:</label>
                      <div class="col-sm-7 pt-2">
                          <input type="checkbox" id="is_check_received"  ref="check_received_flag" value="1" v-model="checkReceived" @click="chooseCheckReceived($event)" :disabled="isCheckPanel">
                          <div v-if="isCheckReceivedValidateMsg" class="margin-bottom-5 validate-warning-msg">Check Received is required</div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="check_no" class="col-sm-5 col-form-label">Check Number:</label>
                      <div class="col-sm-7">
                          <input type="text" class="form-control billingInput" maxlength="10" style="width: 210px;" id="check_no" v-model="checkNumber" name="check_number" v-on:blur="validateCheckNumber($event)" :disabled="isCheckPanel">
                          <div v-if="isCheckNumberValidateMsg" class="margin-bottom-5 validate-warning-msg">Check Number is required</div>
                          <div v-if="isCheckNumberNumericMsg" class="margin-bottom-5 validate-warning-msg">Check Number be numeric</div>
                      </div>
                    </div>
                  </div>
                  <div class="col" style="padding-left: 7px;"  v-if="isCreditPanel == true">
                  <div class="form-group row">
                    <label for="check_no" class="col-sm-5 col-form-label">Onboarding Date:</label>
                    <div class="col-sm-7">
                      <date-picker
                        v-model="onboarding_date"
                        format="MM/DD/YYYY"
                        v-bind:clearable="false"
                        input-class="col-md-12 input-height-30 padding-lr-5 custom-datepicker"
                        >
                        <template v-slot:icon-calendar>
                          <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                        </template>
                      </date-picker>
                    </div>
                  </div>
                  </div>
                  <div class="col" style="padding-left: 7px;"  v-if="isCreditPanel == true">
                  <div class="form-group row">
                    <label for="check_no" class="col-sm-5 col-form-label">Expiration Date:</label>
                    <div class="col-sm-7">
                      <date-picker
                        v-model="new_account_expiration_date"
                        :disabled-date="notBeforeToday"
                        format="MM/DD/YYYY"
                        v-bind:clearable="false"
                        input-class="col-md-12 input-height-30 padding-lr-5 custom-datepicker"
                        >
                        <template v-slot:icon-calendar>
                          <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                        </template>
                      </date-picker>
                    </div>
                  </div>
                  </div>


                </div>
                <div class="row justify-content-center">
                  <button :disabled="disable_purchase_btn" class="btn btn-primary customBtn mt-3" @click="processPayment()">Apply Billing</button>
                </div>
              </div>
            </div>


          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </BillingModal>







        <CheckReceivedOrderUpdateModal :isModalVisible="isCheckOrderUpdateModal"  @close="closeCheckOrderUpdateModal()">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Check Received</div>
          <div slot="body" v-if="isCheckOrderUpdateModal == true">


            <div class="row pay_detail_row">
              <div class="col-md-12" id="pay_detail_row">
                <div class="card card_info">
                  <div class="col" style="padding-left: 7px;">
                  <div class="form-group row">
                    <label for="check_no" class="col-sm-5 col-form-label">Total Amount:</label>
                    <div class="col-sm-7">
                        $<input type="text" class="form-control billingInput" id="total_display_amount" v-model="orderTotalAmount" name="total_display_amount" style="width: 202px; display: inline-block;" disabled="true">
                    </div>
                  </div>
                  </div>
                  <div class="col" style="padding-left: 7px;">
                  <div class="form-group row">
                    <label for="check_no" class="col-sm-5 col-form-label">Invoice No:</label>
                    <div class="col-sm-7">
                        <input type="text" class="form-control billingInput" id="orderInvoiceNo" v-model="orderInvoiceNo" name="orderInvoiceNo" style="width: 210px; display: inline-block;" disabled="true">
                    </div>
                  </div>
                  </div>
                

                  <div id="check_info" class="col" style="padding-left: 7px; display: block;">
                    <div class="form-group row">
                      <label for="check_no" class="col-sm-5 col-form-label">Check Number:</label>
                      <div class="col-sm-7">
                          <input v-validate="'required|numeric'" type="text" class="form-control billingInput" maxlength="10" style="width: 210px;" id="check_no" v-model="checkNumber" name="check_number" v-on:blur="validateCheckNumber($event)">
                          <div v-if="verrors.firstByRule('check_number', 'required')" class="margin-bottom-5 validate-warning-msg">Check No is required</div>
                          <div v-if="verrors.firstByRule('check_number', 'numeric')" class="margin-bottom-5 validate-warning-msg">Check No should be numeric</div>
                          <div v-if="isCheckNumberValidateMsg" class="margin-bottom-5 validate-warning-msg">Check Number is required</div>
                          <div v-if="isCheckNumberNumericMsg" class="margin-bottom-5 validate-warning-msg">Check Number be numeric</div>
                      </div>
                    </div>
                  </div>
                  <div class="col" style="padding-left: 7px;">
                  <div class="form-group row">
                    <label for="check_no" class="col-sm-5 col-form-label">Onboarding Date:</label>
                    <div class="col-sm-7">
                      <date-picker
                        v-model="onboarding_date"
                        format="MM/DD/YYYY"
                        v-bind:clearable="false"
                        input-class="col-md-12 input-height-30 padding-lr-5 custom-datepicker"
                        >
                        <template v-slot:icon-calendar>
                          <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                        </template>
                      </date-picker>
                    </div>
                  </div>
                  </div>
                  <div class="col" style="padding-left: 7px;">
                  <div class="form-group row">
                    <label for="check_no" class="col-sm-5 col-form-label">Expiration Date:</label>
                    <div class="col-sm-7">
                      <date-picker
                        v-model="new_account_expiration_date"
                        :disabled-date="notBeforeToday"
                        format="MM/DD/YYYY"
                        v-bind:clearable="false"
                        input-class="col-md-12 input-height-30 padding-lr-5 custom-datepicker"
                        >
                        <template v-slot:icon-calendar>
                          <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                        </template>
                      </date-picker>
                    </div>
                  </div>
                  </div>


                </div>
                <div class="row justify-content-center">
                  <button :disabled="disable_purchase_btn" class="btn btn-primary customBtn mt-3" @click="updatePaymentStatus()">Update</button>
                </div>
              </div>
            </div>


          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </CheckReceivedOrderUpdateModal>






        <CheckPaymentOrderUpdateModal :isModalVisible="isCheckPaymentOrderUpdateModal"  @close="closeCheckPaymentOrderUpdateModal()">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Check Payment Order</div>
          <div slot="body" v-if="isCheckPaymentOrderUpdateModal == true">


            <div class="row pay_detail_row">
              <div class="col-md-12" id="pay_detail_row">
                <div class="card card_info">
                  <div class="col" style="padding-left: 7px;">
                  <div class="form-group row">
                    <label for="check_no" class="col-sm-5 col-form-label">Total Amount:</label>
                    <div class="col-sm-7">
                        $<input type="text" class="form-control billingInput" id="total_display_amount" v-model="total_display_amount" name="total_display_amount" style="width: 202px; display: inline-block;" disabled="true">
                    </div>
                  </div>
                  </div>
                

                  <div id="check_info" class="col" style="padding-left: 7px; display: block;">
                    <div class="form-group row">
                      <label for="check_no" class="col-sm-5 col-form-label">Check Number:</label>
                      <div class="col-sm-7">
                          <input v-validate="'required|numeric'" type="text" class="form-control billingInput" maxlength="10" style="width: 210px;" id="check_no" v-model="checkNumber" name="check_number" v-on:blur="validateCheckNumber($event)">
                          <div v-if="verrors.firstByRule('check_number', 'required')" class="margin-bottom-5 validate-warning-msg">Check No is required</div>
                          <div v-if="verrors.firstByRule('check_number', 'numeric')" class="margin-bottom-5 validate-warning-msg">Check No should be numeric</div>
                          <div v-if="isCheckNumberValidateMsg" class="margin-bottom-5 validate-warning-msg">Check Number is required</div>
                          <div v-if="isCheckNumberNumericMsg" class="margin-bottom-5 validate-warning-msg">Check Number be numeric</div>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="row justify-content-center">
                  <button :disabled="disable_purchase_btn" class="btn btn-primary customBtn mt-3" @click="updatecheckPaymentStatus()">Update</button>
                </div>
              </div>
            </div>


          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </CheckPaymentOrderUpdateModal>


    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import moment from 'moment';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import BillingModal from './account_lookup_billing_modal.vue';
import CheckReceivedOrderUpdateModal from './account_lookup_billing_modal.vue';
import CheckPaymentOrderUpdateModal from './account_lookup_billing_modal.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import router from '../../router/index.js';
import { store } from '../../store/store';
import EventBus from '../../bus';

  const today1 = new Date();
  today1.setHours(0, 0, 0, 0);

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

import RenewalDateChange from '../admin/renewal_date_change_modal.vue';
import BoardingDateChange from '../admin/onboarding_date_change_modal.vue';


Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

export default {
      props: ['accountId'],
      data() {
        return {
          orderItems: [],
          orderId: '',
          orderInvoiceNo: '',
          orderPaymentMethod: '',
          orderTotalAmount: '',
          totalOrders: [],
          loading: false,
          isCheckOrderUpdateModal: false,
          checkReceived: '',
          checkNumber: '',
          updateOrderId: '',
          updateSubscriptionId: '',
          updateQty: '',
          isEnterpriseAccount: false,
          frequencyoptions: [
            { value: 'yearly', text: 'Yearly' },
            { value: 'monthly', text: 'Monthly' },
          ],
          frequency: 'yearly',
          bundleoptions: [],
          bundle: '',
          seat_qty_options: [
            { value: '', text: '0' },
            { value: 1, text: 1 },
            { value: 2, text: 2 },
            { value: 3, text: 3 },
            { value: 4, text: 4 },
            { value: 5, text: 5 },
            { value: 6, text: 6 },
            { value: 7, text: 7 },
            { value: 8, text: 8 },
            { value: 9, text: 9 },
            { value: 10, text: 10 },
            { value: 11, text: 11 },
            { value: 12, text: 12 },
            { value: 13, text: 13 },
            { value: 14, text: 14 },
            { value: 15, text: 15 },
            { value: 16, text: 16 },
            { value: 17, text: 17 },
            { value: 18, text: 18 },
            { value: 19, text: 19 },
            { value: 20, text: 20 },
          ],
          additionalSeatQty: '',
          bundlePrice: '',
          totalAdditionalPrice: '',
          totalAmount: '',
          subscriptionId: '',
          maxAdditionalSeatLimit: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          country: '',
          payment_method_id: '',
          cardOptions: [],
          state_options: this.state_options = [{ value: '', text: 'Select State' }],
          country_options: [],
          autoRenew: false,
          tempbundlePrice: '',
          temptotalAmount: '',
          tempbundle: '',
          tempunit: '',
          currentpackageId: '',
          currentpackageQty: '',
          usedLicense: '',
          totalLicenseWithoutRenew: '',
          activelicenseCount: '',
          NtotalAmount: '',
          Nunit: '',
          additionalSeatPrice: '',
          accountExpireDate: '',
          type: '',
          annualSubscription: false,
          additionalSeat: '',
          billing_address: '',
          billing_address2: '',
          billing_city: '',
          billing_state: '',
          billing_country: '',
          billing_zip: '',
          billing_phone: '',
          billing_name: '',
          dismissCountWarningDown: 0,
          warning_message: '',
          success_auth_message: '',
          dismissAuthCountDown: 0,
          disableAddSeat: false,
          refundFlag: 0,
          reviewFlag: 0,
          subloading: false,
          isRenewDateChangeModalVisible: false,
          qty_options: [
            { value: '', text: '0' },
            { value: 1, text: 1 },
            { value: 2, text: 2 },
            { value: 3, text: 3 },
            { value: 4, text: 4 },
            { value: 5, text: 5 },
            { value: 6, text: 6 },
            { value: 7, text: 7 },
            { value: 8, text: 8 },
            { value: 9, text: 9 },
            { value: 10, text: 10 },
            { value: 11, text: 11 },
            { value: 12, text: 12 },
            { value: 13, text: 13 },
            { value: 14, text: 14 },
            { value: 15, text: 15 },
            { value: 16, text: 16 },
            { value: 17, text: 17 },
            { value: 18, text: 18 },
            { value: 19, text: 19 },
            { value: 20, text: 20 },
          ],
          qty: '',
          subscriptionPrice: '',
          subscriptionTotal: '',
          licenseType: '',
          overridePrice: '',
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            paymentMethod: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            checkNumber: '',
            checkReceived: false,
            isCCRequired: 0,
            country_options: [],
            state_options: this.state_options = [{ value: '', text: 'Select State' }],
            year_options: [],
            isCheckReceivedValidateMsg: false,
            isCheckNumberValidateMsg: false,
            isCheckNumberNumericMsg: false,
            isCheckPanel: true,
            isCreditPanel: false,
            isBillingModalVisible: false,
            disable_purchase_btn: false,
            onboarding_date: today1,
            renewaldate: '',
            new_account_expiration_date: '',
            total_display_amount: '',
            api_new_account_expiration_date: '',
            isBoardingDateChangeModalVisible: false,
            overrideSubscriptionPrice: '',
            isNumericOnlyErrorMsg: false,
            selectedSubscriptionPrice: '',
            selectedSubscriptionSeatPrice: '',
            isCheckPaymentOrderUpdateModal: false,
            emailIds: process.env.EMAIL_IDS,
            unlimited: false,
        }
      },
      computed: {
        isDeveloperAdmin(){
          if ((this.emailIds.indexOf(this.$store.state.email) > -1)) {
            return true;
          } else {
            return false;
          }
        }
      },
      components: {
        CheckReceivedOrderUpdateModal,
        RenewalDateChange,
        BillingModal,
        BoardingDateChange,
        DatePicker,
        CheckPaymentOrderUpdateModal,
      },
      methods: { 
        updatecheckPaymentStatus() {
          this.$validator.validateAll().then((result) => {
            console.log(this.verrors);
             if ((this.verrors.items.length === 0)) {
              if(this.unitType == 'Seat') {
                axios('/accountlookup-checkpayment-orders',
                    {
                      method: 'POST',
                      data:
                      {
                        "subscription_id": this.subscriptionId,
                        "subscription_price": this.totalAmount,
                        "units": this.unit,
                        "subscription_total": 0,
                        "override_price": 0,
                        "account_id": this.accountId,
                        "additionalSeat": this.additionalSeatQty,
                        "packageId": this.bundle,
                        "additionalSeatPrice": this.additionalSeatPrice,
                        "refundFlag": this.refundFlag,
                        "annualSubscription": this.annualSubscription,
                        "unitType": this.unitType,
                        "check_number": this.checkNumber,
                        "payment_method": 'check',
                        "check_received": 1,
                        "billing_address": this.billing_name,
                        "billing_address2": this.billing_address2,
                        "billing_city": this.billing_city,
                        "billing_state": this.billing_state,
                        "billing_country": this.billing_country,
                        "billing_zip": this.billing_zip,
                        "billing_phone": this.billing_phone,
                        "billing_name": this.billing_name,
                      },
                    }
                  )
                .then((response) => {
                    this.closeCheckPaymentOrderUpdateModal();
                    this.getBillingDetails();
                    this.getOrders();
                    this.paymentDetails();
                    if (response.data.msg != 'failed') {
                      this.success_auth_message = 'Payment done successfully.';
                      this.dismissAuthCountDown = 5;
                    }
                    else {
                      this.warning_message = 'Payment failed.';
                      this.dismissCountWarningDown = 5;
                    }
                })
                .catch(error => {
                    this.process_payment_disable = false;
                });
              }

              if(this.unitType == 'License') {
                axios('/accountlookup-checkpayment-orders',
                    {
                      method: 'POST',
                      data:
                      {
                        "subscription_id": this.subscriptionId,
                        "subscription_price": this.subscriptionPrice,
                        "units": this.unit,
                        "subscription_total": 0,
                        "override_price": 0,
                        "account_id": this.accountId,
                        "additionalSeat": this.additionalSeatQty,
                        "packageId": this.bundle,
                        "additionalSeatPrice": this.additionalSeatPrice,
                        "refundFlag": this.refundFlag,
                        "annualSubscription": this.annualSubscription,
                        "unitType": this.unitType,
                        "check_number": this.checkNumber,
                        "payment_method": 'check',
                        "check_received": 1,
                        "billing_address": this.billing_name,
                        "billing_address2": this.billing_address2,
                        "billing_city": this.billing_city,
                        "billing_state": this.billing_state,
                        "billing_country": this.billing_country,
                        "billing_zip": this.billing_zip,
                        "billing_phone": this.billing_phone,
                        "billing_name": this.billing_name,
                      },
                    }
                  )
                .then((response) => {
                    this.closeCheckPaymentOrderUpdateModal();
                    this.getBillingDetails();
                    this.getOrders();
                    this.paymentDetails();
                    if (response.data.msg != 'failed') {
                      this.success_auth_message = 'Payment done successfully.';
                      this.dismissAuthCountDown = 5;
                    }
                    else {
                      this.warning_message = 'Payment failed.';
                      this.dismissCountWarningDown = 5;
                    }
                })
                .catch(error => {
                    this.process_payment_disable = false;
                });
              }

             }
          })
          .catch(() => {

          });
        },
        onCheckPaymentUpdateOpen(amt) {
          this.verrors.clear();
          this.total_display_amount = amt;
          this.isCheckPaymentOrderUpdateModal = true;
        },
        overridePriceSeatSubTotal() {
          if (this.overridePrice == "") {
            this.NtotalAmount = this.selectedSubscriptionSeatPrice;
            if(this.additionalSeatPrice != '') {
              this.totalAmount = Math.round(parseFloat(this.NtotalAmount) + parseFloat(this.additionalSeatPrice)).toFixed(2);
            }
            else {
              this.totalAmount = Math.round(parseFloat(this.NtotalAmount));
            }
          } else {
            this.isNumericOnlyErrorMsg = false;
            const pattern = /^\d*$/;
            if (!pattern.test(this.overridePrice)) {
                this.isNumericOnlyErrorMsg = true;
                this.overridePrice = "";
            } else {
              this.NtotalAmount = this.overridePrice;
              if(this.additionalSeatPrice != '') {
                this.totalAmount = Math.round(parseFloat(this.NtotalAmount) + parseFloat(this.additionalSeatPrice)).toFixed(2);
              }
              else {
                this.totalAmount = Math.round(parseFloat(this.NtotalAmount));
              }
            }
          }
        },
        overridePriceSubTotal() {
          if (this.overrideSubscriptionPrice == "") {
            if(this.licenseType == 'Bundle License') {
                this.subscriptionTotal = this.selectedSubscriptionPrice;
            }
            else {
                this.subscriptionTotal = this.unit * this.selectedSubscriptionPrice;
            }
          } else {
            this.isNumericOnlyErrorMsg = false;
            const pattern = /^\d*$/;
            if (!pattern.test(this.overrideSubscriptionPrice)) {
                this.isNumericOnlyErrorMsg = true;
                this.overrideSubscriptionPrice = "";
                //this.subscriptionTotal = "";
                if (this.subscriptionId) {
                    //this.subscriptionTotal = this.unit * this.selectedSubscriptionPrice;
                }
            } else {
              this.subscriptionTotal = this.unit * this.overrideSubscriptionPrice;
            }
          }
        },

        onBillingOpen(amt) {
          if(this.orderPaymentMethod == 'check') {
            this.initial();
            this.verrors.clear();
            this.isCheckOrderUpdateModal = true;
          }
          else if(this.orderId != '') {
            alert("Payment is pending. Can't purchase again");
            return false;
          }
          else {
            this.initial();
            this.total_display_amount = amt;
            this.verrors.clear();
            this.isBillingModalVisible = true;
          }
        },
        initial() {
          const today2 = new Date(this.api_new_account_expiration_date);
          today2.setHours(0, 0, 0, 0);
          this.new_account_expiration_date = today2;
        },
        FollowDate(value) {
          return moment(String(value)).utc().format('ddd. MMM. D, YYYY - h:mm A')
        },
        notBeforeToday(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date < today;
        },

        processPayment() {
          this.$validator.validateAll().then((result) => {
              console.log(this.verrors);
              if ((this.verrors.items.length === 0) && this.validateCheckReceived()) {
                if((this.paymentMethod == 'credit_card') && (this.total_display_amount == 0)) {
                  alert("Total amount should be greater than zero for credit card payment.");
                  return false;
                }
                else {
                this.disable_purchase_btn = true;
                

                
                if(this.unitType == 'Seat') {
                  const boardingStr = moment(this.onboarding_date).format('YYYY-MM-DD HH:mm:ss')
                  const expirationStr = moment(this.new_account_expiration_date).format('YYYY-MM-DD HH:mm:ss')


                  axios('/account-lookup/new-account/orders', 
                  {
                      method: 'POST',
                      data: {
                        "boardingDate": boardingStr,
                        "expirationDate": expirationStr,
                        "subscription_id": this.subscriptionId,
                        "packageId": this.bundle,
                        "subscription_price": this.totalAmount,
                        "override_price": this.overridePrice,
                        "units": this.unit,
                        "additionalSeat": this.additionalSeatQty,
                        "type": this.frequency,
                        "unitType": this.unitType,
                        "subscription_total": this.totalAmount,
                        "account_id": this.accountId,
                        "billing_name": this.billingName,
                        "billing_address": this.billingAddress,
                        "billing_address2": this.billingAddress2,
                        "billing_city": this.billingCity,
                        "billing_state": this.billingState,
                        "billing_country": this.billingCountry,
                        "billing_zip": this.billingZip,
                        "billing_phone": this.billingPhone,
                        "payment_method": this.paymentMethod,
                        "name_oncard": this.nameOnCard,
                        "card_number": this.cardNumber,
                        "exp_month": this.expMonth,
                        "exp_year": this.expYear.toString().substr(-2),
                        "cvv_value": this.cvvValue,
                        "check_number": this.checkNumber,
                        "check_received": this.checkReceived,
                        "additionalSeatPrice": this.additionalSeatPrice,
                        "bundlePrice": this.selectedSubscriptionSeatPrice,

                      },
                  })
                  .then((response) => {
                    this.disable_purchase_btn = false;
                    this.isBillingModalVisible = false;
                    this.getBillingDetails();
                    this.getOrders();
                    this.paymentDetails();
                    if (response.data.msg != 'failed') {
                      this.success_auth_message = response.data.displaymsg;
                      this.dismissAuthCountDown = 5;
                      let page_url = this.$route.fullPath;
                      let active_tab = 'BillingTab';
                      let active_sub_tab = '';
                      this.$store.dispatch('active_tab', { page_url, active_tab, active_sub_tab });
                      router.push(this.$store.state.page_url);
                      location.reload();
                    }
                    else {
                      this.warning_message = 'Payment failed.';
                      this.dismissCountWarningDown = 5;
                    }
                  })
                  .catch(error => {
                    this.disable_pu
                    rchase_btn = false;
                  });
                }
                else {
                  const boardingStr = moment(this.onboarding_date).format('YYYY-MM-DD HH:mm:ss')
                  const expirationStr = moment(this.new_account_expiration_date).format('YYYY-MM-DD HH:mm:ss')

                  axios('/account-lookup/new-account/orders', 
                  {
                      method: 'POST',
                      data: {
                        "boardingDate": boardingStr,
                        "expirationDate": expirationStr,
                        "subscription_id": this.subscriptionId,
                        "packageId": this.bundle,
                        "subscription_price": this.subscriptionPrice,
                        "override_price": this.overrideSubscriptionPrice,
                        "units": this.unit,
                        "additionalSeat": this.additionalSeatQty,
                        "type": this.frequency,
                        "unitType": this.unitType,
                        "subscription_total": this.subscriptionTotal,
                        "account_id": this.accountId,
                        "billing_name": this.billingName,
                        "billing_address": this.billingAddress,
                        "billing_address2": this.billingAddress2,
                        "billing_city": this.billingCity,
                        "billing_state": this.billingState,
                        "billing_country": this.billingCountry,
                        "billing_zip": this.billingZip,
                        "billing_phone": this.billingPhone,
                        "payment_method": this.paymentMethod,
                        "name_oncard": this.nameOnCard,
                        "card_number": this.cardNumber,
                        "exp_month": this.expMonth,
                        "exp_year": this.expYear.toString().substr(-2),
                        "cvv_value": this.cvvValue,
                        "check_number": this.checkNumber,
                        "check_received": this.checkReceived,

                      },
                  })
                  .then((response) => {
                    this.disable_purchase_btn = false;
                    this.isBillingModalVisible = false;
                    this.getBillingDetails();
                    this.getOrders();
                    this.paymentDetails();
                    if (response.data.msg != 'failed') {
                      this.success_auth_message = 'Payment done successfully.';
                      this.dismissAuthCountDown = 5;
                      let page_url = this.$route.fullPath;
                      let active_tab = 'BillingTab';
                      let active_sub_tab = '';
                      this.$store.dispatch('active_tab', { page_url, active_tab, active_sub_tab });
                      router.push(this.$store.state.page_url);
                      location.reload();
                    }
                    else {
                      this.warning_message = 'Payment failed.';
                      this.dismissCountWarningDown = 5;
                    }
                  })
                  .catch(error => {
                    this.disable_purchase_btn = false;
                  });

                }
                }
              }
          }).catch(() => {
            // catches the error;
          });

        },





        choosePaymentMode(event) {
          if(event.target.value == 'credit_card') {
              this.isCCRequired = 1;
              this.isCheckNumberValidateMsg = false;
              this.isCheckNumberNumericMsg = false;
              this.isCheckPanel = true;
              this.isCreditPanel = false;
          }
          else {
              this.isCCRequired = 0;
              this.isCheckPanel = false;
              this.isCreditPanel = true;
          }
        },
        chooseCheckReceived(event) {
          if (event.target.checked) {
            this.isCheckReceivedValidateMsg = false;
            if (this.checkNumber == '') {
                this.isCheckNumberValidateMsg = true;
                this.isCheckNumberNumericMsg = false;
            }
          } else {
              this.isCheckNumberValidateMsg = false;
          }
        },
        validateCheckNumber(event) {
          const pattern = /^\d*$/;
          if (this.checkNumber == '') {
            this.isCheckNumberValidateMsg = false;
            this.isCheckReceivedValidateMsg = false;
          } else {
            if (!pattern.test(this.checkNumber)) {
              this.checkNumber = '';
              this.isCheckNumberNumericMsg = true;
              this.isCheckNumberValidateMsg = false;
            } else {
              this.isCheckNumberNumericMsg = false;
              this.isCheckNumberValidateMsg = false;
              if (!this.checkReceived) {
                  this.isCheckReceivedValidateMsg = true;
              }
            }
          }
        },
        validateCheckReceived() {
          var isFormSubmit = false;
          if (!this.checkReceived && this.checkNumber == '') {
              isFormSubmit = true;
          } else {
              if (this.checkReceived && this.checkNumber == '') {
                  this.isCheckNumberValidateMsg = true;
                  this.isCheckNumberNumericMsg = false;
                  isFormSubmit = false;
              } else {
                  const pattern = /^\d*$/;
                  if (!pattern.test(this.checkNumber)) {
                      this.isCheckNumberNumericMsg = true;
                      this.isCheckNumberValidateMsg = false;
                      isFormSubmit = false;
                  } else {
                      if (!this.checkReceived) {
                          isFormSubmit = false;
                      } else {
                          isFormSubmit = true;
                      }
                  }
              }
          }
          return isFormSubmit;
        },
        billingPhoneValid: function(event) {
          var billing_phone = this.billingPhone;
          this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex: function() {
          return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex: function() {
          if (this.billingCountry == "US") {
              return /^[0-9]{5}(?:-[0-9]{4})?$/;
          } else if (this.billingCountry == "CA") {
              return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
          }
          return /./;
        },
        getLicensePriceforSubscription: function() {
          axios('/getsubscriptionPrice',
            {
              method: 'GET',
              params: {
                subscriptionId: this.subscriptionId,
                qty: this.unit,
                accountId: this.accountId,
              }
            }
          )
          .then(response => {
              var price = response.data;
              if(this.licenseType == 'Bundle License') {
                this.subscriptionTotal = price;
              }
              else {
                this.subscriptionTotal = parseFloat(price * this.unit).toFixed(2);
              }
              this.subscriptionPrice = response.data;
          })
          .catch(error => {

          });
        },
        closeBoardingDateModal() {
          this.isBoardingDateChangeModalVisible = false;
          this.getBillingDetails();
          this.getOrders();
        }, 
        openBoardingDateModal(date) {
          this.isBoardingDateChangeModalVisible = true;
          this.$refs.BoardingDateChangeModal.initial(date);
        },

        closeRenewalDateModal() {
          this.isRenewDateChangeModalVisible = false;
          this.getBillingDetails();
          this.getOrders();
        }, 
        openRenewalDateModal(date) {
          this.isRenewDateChangeModalVisible = true;
          this.$refs.RenewDateChangeModal.initial(date);
        },
        countDownWarningChanged(dismissCountWarningDown) {
          this.dismissCountWarningDown = dismissCountWarningDown
        },
        billingModeChange(event) {
          if (this.type == 'yearly') {
            this.frequency = 'yearly';
            alert("You can't change to monthly billing mode from yearly");
            return false;
          }
          else {
            if(this.type == 'monthly') {
              if(this.frequency == 'yearly') {
                this.annualSubscription = true;
                this.disableAddSeat = true;
                this.additionalSeatQty = '';
              }
              else {
                this.annualSubscription = false;
                this.disableAddSeat = false;
                this.additionalSeatQty = '';
              }
              this.getPriceforSubscription();

              //this.getBillingDetails();




            }
          }
        },
        countDownAuthChanged(dismissAuthCountDown) {
          this.dismissAuthCountDown = dismissAuthCountDown;
        },
        onSubmitPaymentDetails() {
          if(this.payment_method_id == '') {
            alert("Credit Card information not available.");
            return false;
          }
          else {
            axios('/accountlookup-billing-paymentmethod-update/' + this.accountId, 
            {
              method: 'POST',
              data: {
                "payment_method_id": this.payment_method_id,
                "autoRenew": this.autoRenew,
                "address": this.address,
                "city": this.city,
                "state": this.state,
                "zip": this.zip,
                "country": this.country,
              },
            })
            .then((response) => {

                this.success_auth_message = 'Payment details updated successfully.';
                this.dismissAuthCountDown = 5;
                this.getBillingDetails();
                this.getOrders();
            })
            .catch(error => {
                this.process_payment_disable = false;
            });

          }
        },

        onLicenseSubmit() {

          if(this.payment_method_id == '') {
            alert("Credit Card information not available.");
            return false;
          }
          else {
            axios('/accountlookup-subscription-license-orders', 
            {
              method: 'POST',
              data: {
                "subscription_id": this.subscriptionId,
                "subscription_price": this.subscriptionPrice,
                "units": this.unit,
                "subscription_total": this.subscriptionTotal,
                "account_id": this.accountId,
                "billing_address": this.billing_name,
                "billing_address2": this.billing_address2,
                "billing_city": this.billing_city,
                "billing_state": this.billing_state,
                "billing_country": this.billing_country,
                "billing_zip": this.billing_zip,
                "billing_phone": this.billing_phone,
                "billing_name": this.billing_name,
                "payment_method": "credit_card",
                "payment_method_id": this.payment_method_id,
              },
            })
            .then((response) => {

                this.getBillingDetails();
                this.getOrders();
                this.paymentDetails();
                if (response.data.msg != 'failed') {
                  this.success_auth_message = 'Payment done successfully.';
                  this.dismissAuthCountDown = 5;
                }
                else {
                  this.warning_message = 'Payment failed.';
                  this.dismissCountWarningDown = 5;
                }
            })
            .catch(error => {
                this.process_payment_disable = false;
            });

          }
        },

        onSubmit() {
          if(this.payment_method_id == '') {
            alert("Credit Card information not available.");
            return false;
          }
          else {
            if((this.currentpackageId == this.bundle) && (this.additionalSeatQty == '') && (this.annualSubscription == false)) {
              alert("You are already subscribed to this bundle. Please upgrade your bundle to proceed.");
              return false;
            }
            else {
            axios('/accountlookup-subscription-orders', 
            {
              method: 'POST',
              data: {
                "subscription_id": this.subscriptionId,
                "subscription_price": this.totalAmount,
                "units": this.unit,
                "subscription_total": this.totalAmount,
                "account_id": this.accountId,
                "additionalSeat": this.additionalSeatQty,
                "packageId": this.bundle,
                "additionalSeatPrice": this.additionalSeatPrice,
                "billing_address": this.billing_name,
                "billing_address2": this.billing_address2,
                "billing_city": this.billing_city,
                "billing_state": this.billing_state,
                "billing_country": this.billing_country,
                "billing_zip": this.billing_zip,
                "billing_phone": this.billing_phone,
                "billing_name": this.billing_name,
                "payment_method": "credit_card",
                "payment_method_id": this.payment_method_id,
                "refundFlag": this.refundFlag,
                "annualSubscription": this.annualSubscription,
              },
            })
            .then((response) => {

                this.getBillingDetails();
                this.getOrders();
                this.paymentDetails();
                if (response.data.msg != 'failed') {
                  this.success_auth_message = 'Payment done successfully.';
                  this.dismissAuthCountDown = 5;
                }
                else {
                  this.warning_message = 'Payment failed.';
                  this.dismissCountWarningDown = 5;
                }
            })
            .catch(error => {
                this.process_payment_disable = false;
            });

            }
          }
        },


        getCountryLists() {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
                this.country_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getStateLists(CountryCode) {
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
                this.state_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getStatusIcon(status) {
          if (status == "SUCCESS") {
            return 'fa fa-check green_tick';
          } else {
            return 'fa fa-location-arrow red_tick';
          }
        },
        getPaymentStatus(status) {
          if (status == 'FAILED') {
            return 'Due';
          } else if(status == 'PENDING') {
            return 'Due';
          } else {
            return 'Paid';
          }
        },
        getMonthlyInvoicePdf(item) {
          let pdfEndPoint;
          pdfEndPoint = '/getMonthlyOrderInvoicePdf';
          axios(pdfEndPoint,
            {
              method: 'POST',
              data: {
                  "orderId": item.orderId,
                  "accountId": this.accountId,
              }
            },
          )
          .then(response => {
            window.open(response.data.invoice_filepath, '_blank');
          })
          .catch(error => {
            console.log(error)
          });
        },
        getInvoicePdf(item) {
          let pdfEndPoint;
          if(this.isEnterpriseAccount) {
             pdfEndPoint = '/getEnterpriseOrderInvoicePdf';
          }
          else {
             pdfEndPoint = '/getOrderInvoicePdf';
          }
          axios(pdfEndPoint,
            {
              method: 'POST',
              data: {
                  "billing": {
                      "billing_name": item.billingName,
                      "billing_address": item.address,
                      "billing_address2": item.address2,
                      "billing_city": item.city,
                      "billing_country": item.countryCode,
                      "billing_phone": item.phoneNumber,
                      "billing_state": item.stateCode,
                      "billing_zip": item.zipCode,
                      "billing_primary_admin": item.billingPrimaryAdmin
                  },
                  "orderId": item.orderId
              }
            },
          )
          .then(response => {
            window.open(response.data.invoice_filepath, '_blank');
          })
          .catch(error => {
            console.log(error)
          });
        },
        showCheckOrderUpdateModal() {
          this.isCheckOrderUpdateModal = true;
          this.verrors.clear();
        },
        closeCheckOrderUpdateModal() {
          this.isCheckOrderUpdateModal = false;
          this.verrors.clear();
          this.checkNumber = '';
        },
        closeCheckPaymentOrderUpdateModal() {
          this.isCheckPaymentOrderUpdateModal = false;
          this.verrors.clear();
          this.checkNumber = '';
        },
        updatePaymentStatus() {
          this.$validator.validateAll().then((result) => {
            console.log(this.verrors);
             if ((this.verrors.items.length === 0)) {
              const boardingStr = moment(this.onboarding_date).format('YYYY-MM-DD HH:mm:ss')
              const expirationStr = moment(this.new_account_expiration_date).format('YYYY-MM-DD HH:mm:ss')
              axios('/update-order-status/' + this.accountId,
                  {
                    method: 'PATCH',
                    data:
                    {
                      "order_id": this.orderId,
                      "check_number": this.checkNumber,
                      "boardingDate": boardingStr,
                      "expirationDate": expirationStr,
                    },
                  }
                )
              .then((resp) => {
                this.disable_purchase_btn = false;
                this.isCheckOrderUpdateModal = false;
                this.getBillingDetails();
                this.getOrders();
                this.paymentDetails();
                if (response.data.msg != 'failed') {
                  this.success_auth_message = 'Payment done successfully.';
                  this.dismissAuthCountDown = 5;
                  let page_url = this.$route.fullPath;
                  let active_tab = 'BillingTab';
                  let active_sub_tab = '';
                  this.$store.dispatch('active_tab', { page_url, active_tab, active_sub_tab });
                  router.push(this.$store.state.page_url);
                  location.reload();
                }
                else {
                  this.warning_message = 'Payment failed.';
                  this.dismissCountWarningDown = 5;
                }

              })
              .catch(error => {
                this.disable_purchase_btn = false;
                this.isCheckOrderUpdateModal = false;
              });
             }
          })
          .catch(() => {

          });
        },
        navigate(){
          this.$router.push(this.$router.currentRoute.fullPath)
          this.$router.go();
        },
        frequencyChange() {
          if(this.type == 'monthly') {
            this.packageDetails();
            setTimeout(() => {
            if((this.totalLicenseWithoutRenew > this.tempunit) && (this.currentpackageQty < this.tempunit)) {
              this.bundle = this.currentpackageId;
              this.packageDetailsUpdate();
              alert("Please upgrade bundle.");
              return false;
            }
            else if(this.usedLicense > this.tempunit) {
              if((this.currentpackageQty > this.tempunit)) {
                alert("Please inactivate the mentees first and then try to downgrade.");
              }
              else {
                alert("Please upgrade bundle.");
              }
              this.bundle = this.currentpackageId;
              this.packageDetailsUpdate();
              return false;
            }
            else {
              this.getPriceforSubscription();
              this.getAdditionalSeatMaxQuantity();
              this.disableAddSeat = true;
              this.additionalSeatQty = '';
            }
            }, 1500);          
          }
          if(this.type == 'yearly') {
            this.packageDetails();
            setTimeout(() => {
            if(this.currentpackageQty > this.tempunit) {
              alert("Please upgrade your package.");
              this.bundle = this.currentpackageId;
              this.packageDetailsUpdate();
              return false;
            }
            else if(this.totalLicenseWithoutRenew > this.tempunit) {
              alert("Please upgrade your package.");
              this.bundle = this.currentpackageId;
              this.packageDetailsUpdate();
              return false;
            }
            else {
              this.getPriceforSubscription();
              this.getAdditionalSeatMaxQuantity();
              this.disableAddSeat = true;
              this.additionalSeatQty = '';
            }
            }, 1500);
          }
        },
        billingModeChangeNewAccount(event) {
          if(this.frequency == 'yearly') {
            this.additionalSeatQty = '';
          }
          else {
            this.additionalSeatQty = '';
          }
          this.getAdditionalSeatMaxQuantity();
          this.getPriceforSubscriptionForNewAccount();
        },
        frequencyChangeNewAccount() {
          this.getPriceforSubscriptionForNewAccount();
          this.getAdditionalSeatMaxQuantity();
          this.additionalSeatQty = '';
        },

        getLicensePriceforSubscriptionNewAccount: function() {
          axios('/getsubscriptionPriceNewAccount',
            {
              method: 'GET',
              params: {
                subscriptionId: this.subscriptionId,
                qty: this.unit,
                accountId: this.accountId,
              }
            }
          )
          .then(response => {
              var price = response.data;
              if (this.overrideSubscriptionPrice == "") {
                if(this.licenseType == 'Bundle License') {
                  this.subscriptionTotal = price;
                  this.selectedSubscriptionPrice = this.subscriptionTotal;
                }
                else {
                  this.subscriptionTotal = parseFloat(price * this.unit).toFixed(2);
                  this.selectedSubscriptionPrice = price;
                }
                this.subscriptionPrice = response.data;
              }
              else {
                this.subscriptionTotal = this.unit * this.overrideSubscriptionPrice;
              }
          })
          .catch(error => {

          });
        },

        getAdditionalPriceforNewAccountSubscription: function () {
          axios('/getsubscriptionPriceNewAccount',
            {
              method: 'GET',
              params: {
                subscriptionId: this.subscriptionId,
                qty: this.additionalSeatQty,
                accountId: this.accountId,
                type: this.frequency,
              }
            }
          )
          .then(response => {
              var price = response.data;
              this.additionalSeatPrice = price;
              if(this.overridePrice != '') {
                this.totalAmount = Math.round(parseFloat(this.overridePrice) + parseFloat(price)).toFixed(2);
              }
              else if(this.unitType == 'Seat') {
                if(this.NtotalAmount > 0) {
                  this.totalAmount = Math.round(parseFloat(this.NtotalAmount) + parseFloat(price)).toFixed(2);
                }
                else {
                  if(price > 0) {
                    this.totalAmount = price;
                  }
                  else {
                    this.totalAmount = this.bundlePrice;
                  }
                }
              }
              if(this.Nunit != '') {
                this.unit = parseInt(this.Nunit + this.additionalSeatQty);
              }
              else {
                if(this.additionalSeatQty != '') {
                  this.unit = parseInt(this.additionalSeatQty);
                }
              }
          })
          .catch(error => {

          });
        },
        getAdditionalPriceforSubscription: function() {
          axios('/getsubscriptionPrice',
            {
              method: 'GET',
              params: {
                subscriptionId: this.subscriptionId,
                qty: this.additionalSeatQty,
                accountId: this.accountId,
              }
            }
          )
          .then(response => {
              var price = response.data;
              this.additionalSeatPrice = price;
              if(this.unitType == 'Seat') {
                if(this.NtotalAmount != '') {
                  this.totalAmount = Math.round(parseFloat(this.NtotalAmount) + parseFloat(price)).toFixed(2);
                }
                else {
                  if(price > 0) {
                    this.totalAmount = price;
                  }
                  else {
                    this.totalAmount = this.bundlePrice;
                  }
                  
                }
                
              }
              if(this.Nunit != '') {
                this.unit = parseInt(this.Nunit + this.additionalSeatQty);
              }
              else {
                if(this.additionalSeatQty != '') {
                  this.unit = parseInt(this.additionalSeatQty);
                }
                
              }
          })
          .catch(error => {

          });
        },
        getPriceforSubscriptionForNewAccount: function() {
          this.overridePrice = '';
          this.refundFlag = 0;
          this.additionalSeatPrice = '';
          axios('/desktop/get-account-lookup-seat-subscription-review-new-account/'+ this.accountId + '/' + this.bundle,
          {
            method: 'GET',     
            params: {
              frequency: this.frequency,
            }

          })
          .then(resp => {        
            this.totalAmount = resp.data.totalAmount;
            this.NtotalAmount = resp.data.NtotalAmount;
            this.selectedSubscriptionSeatPrice = this.totalAmount;
            this.bundlePrice = resp.data.packageNPrice;
            this.totalAdditionalPrice = resp.data.additionalNSeatPrice;
            this.proratedAmount = resp.data.proratedAmount;
            this.unit = resp.data.units;
            this.Nunit = resp.data.units;
            this.refundFlag = resp.data.refundFlag;
            this.unlimited = resp.data.unlimited;
          })
          .catch(() => {
          });      
        },        
        getPriceforSubscription: function() {
          this.refundFlag = 0;
          this.additionalSeatPrice = '';
          axios('/desktop/get-account-lookup-seat-subscription-review/'+ this.accountId + '/' + this.bundle,
          {
            method: 'GET',     
            params: {
              annualSubscription: this.annualSubscription,
            }

          })
          .then(resp => {        
            this.totalAmount = resp.data.totalAmount;
            this.NtotalAmount = resp.data.totalAmount;
            this.bundlePrice = resp.data.packageNPrice;
            this.totalAdditionalPrice = resp.data.additionalNSeatPrice;
            this.proratedAmount = resp.data.proratedAmount;
            this.unit = resp.data.units;
            this.Nunit = resp.data.units;
            this.refundFlag = resp.data.refundFlag;
          })
          .catch(() => {
          });      
        },        
        packageDetailsUpdate() {
          axios('/desktop/get-account-package-details/'+ this.bundle,
          {
            method: 'GET',
            params: {
              type: this.type,
            }
          })
          .then(response => {     
            this.bundlePrice = response.data.total_amt;
            this.totalAmount = response.data.total_amt;
            this.bundle = response.data.packageId;
            this.Nunit = response.data.unit;
            this.unit = response.data.unit;
          })
          .catch(() => {
          });      
        },
        packageDetails() {
          axios('/desktop/get-account-package-details/'+ this.bundle,
          {
            method: 'GET',
            params: {
              type: this.type,
            }
          })
          .then(response => {     
            this.tempbundlePrice = response.data.total_amt;
            this.temptotalAmount = response.data.total_amt;
            this.tempbundle = response.data.packageId;
            this.tempunit = response.data.unit;
          })
          .catch(() => {
          });      
        },

        paymentDetails() {
          axios('/desktop/get-account-payment-details/'+ this.accountId,
          {
            method: 'GET',
            params: {
              payment_method_id: this.payment_method_id,
            }

          })
          .then(response => {     
            this.country = response.data.country;
            this.getStateLists(this.country);
            this.address = response.data.address;
            this.city = response.data.city;
            this.state = response.data.state;
            this.zip = response.data.zip;
            this.payment_method_id = response.data.payment_method_id;
            this.cardOptions = response.data.cardOptions;
            this.billing_address = response.data.address;
            this.billing_address2 = response.data.address2;
            this.billing_city = response.data.city;
            this.billing_state = response.data.state;
            this.billing_country = response.data.country;
            this.billing_zip = response.data.zip;
            this.billing_phone = response.data.phoneno;
            this.billing_name = response.data.billingname;



          })
          .catch(() => {
          });      
        },
        getAdditionalSeatMaxQuantity() {
          axios('/desktop/get-account-seat-max-seat/'+ this.bundle,
          {
            method: 'GET',
          })
          .then(resp => {     
            this.maxAdditionalSeatLimit = resp.data.maxAdditionalSeatLimit;
            
            if(this.maxAdditionalSeatLimit != '') {
              this.seat_qty_options = [];
              var qty =  { value: '', text: 0 };
              this.seat_qty_options.push(qty);
              for(var i=1; i <= this.maxAdditionalSeatLimit; i++) {
                  var qty = {value: i, text: i};
                  this.seat_qty_options.push(qty);
              }
            }

          })
          .catch(() => {
          });      

        },
        getBillingDetails() {
          this.subloading = true;
          this.overrideSubscriptionPrice = '';
          this.overridePrice = '';
          this.refundFlag = 0;
          axios('/lookup/get-account-license-seat-subscription-lists/' + this.accountId,
            {
              method: 'GET',
              params: {
                type: this.type,
                annualSubscription: this.annualSubscription,
              }
                
            },
          )
          .then(response => {
            this.subloading = false;
            this.unlimited = response.data.unlimited;
            this.frequency = response.data.frequency;
            if(this.annualSubscription == false) {
              this.type = response.data.type;
            }
            this.orderId = response.data.orderId;
            this.orderInvoiceNo = response.data.orderInvoiceNo;
            this.orderTotalAmount = response.data.orderTotalAmount;
            this.orderPaymentMethod = response.data.orderPaymentMethod;

            this.api_new_account_expiration_date = response.data.new_account_expire_date;
            this.reviewFlag = response.data.reviewFlag;
            this.additionalSeat = response.data.additionalSeat;
            this.unitType = response.data.unitType;
            this.totalAdditionalPrice = response.data.additionalPrice;
            this.bundleoptions = response.data.bundleOptions;
            this.subscriptionId = response.data.subscriptionId;
            this.bundlePrice = response.data.total_amt;
            this.totalAmount = response.data.total_amt;
            if(response.data.flag == 0) {
              this.NtotalAmount = this.totalAmount;
              this.Nunit = response.data.unit;
            }
            this.selectedSubscriptionSeatPrice = this.NtotalAmount;
            this.bundle = response.data.packageId;
            this.totalLicenseWithoutRenew = response.data.totalLicenseWithoutRenew;
            this.usedLicense = response.data.usedLicense;
            this.accountExpireDate = response.data.accountExpireDate;
            this.packageId = response.data.packageId;
            this.currentpackageId = response.data.packageId;
            this.currentpackageQty = response.data.currentpackageQty;
            this.unit = response.data.unit;
            
            this.maxAdditionalSeatLimit = response.data.maxAdditionalSeatLimit;
            this.additionalSeatQty = '';
            this.autoRenew = response.data.autoRenew;
            if(this.maxAdditionalSeatLimit != '') {
              this.seat_qty_options = [];
              var qty =  { value: '', text: 0 };
              this.seat_qty_options.push(qty);
              for(var i=1; i <= this.maxAdditionalSeatLimit; i++) {
                  var qty = {value: i, text: i};
                  this.seat_qty_options.push(qty);
              }
            }
            if(this.unitType == 'License') {
              if((this.unit > 1)) {
                this.qty_options = [];
                var qty =  { value: '', text: 'Select' };
                this.qty_options.push(qty);
                for(var i=this.unit; i < 21; i++) {
                    var qty = {value: i, text: i};
                    this.qty_options.push(qty);
                }
              }
              else {
                this.qty_options = [];
                var qty =  { value: '', text: 'Select' };
                this.qty_options.push(qty);
                for(var i=this.unit; i < 21; i++) {
                    var qty = {value: i, text: i};
                    this.qty_options.push(qty);
                }
              }
              this.subscriptionTotal = response.data.total_amt;;
              this.subscriptionPrice = response.data.subscriptionPrice;;
              this.selectedSubscriptionPrice = this.subscriptionPrice;
              this.licenseType = response.data.licenseType;
            }
            

           })
          .catch(error => {
            console.log(error)
          });

        },
        getOrders() {

          axios('/account_lookup_orders/' + this.accountId,
            {
              method: 'GET'
                
            },
          )
          .then(response => {
            this.loading = false;
            this.orderItems = response.data.orderItems;
            this.totalOrders = response.data.totalOrders[0];
            this.isEnterpriseAccount = response.data.isEnterprise;
           })
          .catch(error => {
            console.log(error)
          });

        },
        getExpiryYears() {       
          var d = new Date();
          var start_year = d.getFullYear().toString().substr(-2)
          var end_year =  parseInt(start_year) + 20;
          //alert(end_year)

          this.year_options = [
              { value: '', text: 'YY' },
            ];
          for(var i=start_year;i<=end_year;i++) {
              var yoptions = { value: i, text: i };
              this.year_options.push(yoptions);
          }        
        },

      },
      created: function () {
        this.loading = true;
        this.subloading = true;
        this.getExpiryYears();
        this.orderItems = [];
        this.totalOrders = [];
        this.getBillingDetails();
        this.getCountryLists();
        this.paymentDetails();

        axios('/account_lookup_orders/' + this.accountId,
          {
            method: 'GET'
              
          },
        )
        .then(response => {
          this.loading = false;
          this.orderItems = response.data.orderItems;
          this.totalOrders = response.data.totalOrders[0];
          this.isEnterpriseAccount = response.data.isEnterprise;
         })
        .catch(error => {
          console.log(error)
        });
      }
    }

</script>
<style scoped>
.admin_heading_2 { width: 20%; }
.admin_heading_4 { width: 23%; }
.admin_heading_8_1 { width: 17%; }
.orders_heading_1 { width: 10%; }
.orders_heading_2 { width: 12%; }
.orders_heading_5 { width: 10%; }
.orders_heading_8 { width: 19%; }
.orders_heading_7 { width: 10%; }
.orders_heading_9 { width: 9%; float: left; }
.orders_heading_5_2 { width: 13%; }
.orders_heading_6_2 { width: 14%; }
.orders_heading_7_2 { width: 16%; }
.orders_heading_8_2 { width: 17%; }
.orders_heading_6 { width: 8%; }

.order_items {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  color: #707070;
}
.purchase_items:nth-child(odd) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #FFFFFF !important;
  color: #707070;
}
.purchase_items:nth-child(even) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #e9e9e9 !important;
  color: #707070;
}
.order_items .crm_admin_field_lists { padding: 10px; }
.green_tick { color: #479a4b; }
.red_tick { color: red; transform: rotate(45deg); }
.invoice_link { color: #00ACEE; }
.orderBtn {
    color: #FFF;
    background-color: #00acee;
    border: 1px solid #00acee;
    padding: 8px !important;
    font-size: 13px;
    font-weight: 900;
}
.col-form-label {
  font-size: 13px !important;
  font-weight: 900;
}
.check_received_lbl {
  padding: 5px 15px;
  margin: 2px 0px;
}
.field_1 {
  width: 12%;
  float: left; 
}
.field_2 {
  width: 25%;
  float: left; 
}
.field_3 {
  width: 12%;
  float: left; 
}
.field_4 {
  width: 12%;
  float: left; 
}
.field_5 {
  width: 12%;
  float: left; 
}
.field_6 {
  width: 12%;
  float: left; 
}
.field_7 {
  width: 15%;
  float: left; 
}
.pfield_1 {
  width: 12%;
  float: left; 
}
.pfield_2 {
  width: 14%;
  float: left; 
}
.pfield_3 {
  width: 14%;
  float: left; 
}
.pfield_4 {
  width: 12%;
  float: left; 
}
.pfield_5 {
  width: 12%;
  float: left; 
}
.pfield_6 {
  width: 12%;
  float: left; 
}
.pfield_7 {
  width: 12%;
  float: left; 
}
.pfield_8 {
  width: 12%;
  float: left; 
}
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:focus {
  color: #FFF !important; 
  border-radius: 0px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  padding: 3px 20px;
}
.admin_h_1 {
  width: 14%;
  float: left;
}
.admin_h_2 {
  width: 14%;
  float: left;
}
.admin_h_3 {
  width: 12%;
  float: left;
}
.admin_h_4 {
  width: 12%;
  float: left;
}
.admin_h_5 {
  width: 12%;
  float: left;
}
.admin_h_6 {
  width: 12%;
  float: left;
}
.admin_h_7 {
  width: 12%;
  float: left;
}
.admin_h_8 {
  width: 12%;
  float: left;
}
.orders_heading_1 {
  width: 10%;
  float: left;
}
.orders_heading_2 {
  width: 12%;
  float: left;
}
.orders_heading_3 {
  width: 15%;
  float: left;
}
.orders_heading_3_1 {
  width: 27%;
  float: left;
}
.orders_heading_4 {
  width: 15%;
  float: left;
}
.orders_heading_5 {
  width: 10%;
  float: left;
}
.orders_heading_9_1 {
  width: 13%;
  float: left;
}
.orders_heading_5_1, .orders_heading_6_1 {
  width: 13%;
  float: left;
}
.orders_heading_6 {
  width: 8%;
  float: left;
}
.orders_heading_7 {
  width: 8%;
  float: left;
}
.orders_heading_8 {
  width: 12%;
  float: left;
}
.orders_heading_9 {
  width: 10%;
  float: left;
}
.heading {
  font-size: 18px;
  font-weight: bold;
  color: #707070;
}
.field_l_1 {
  width: 30%;
  float: left;
}
.field_l_2 {
  width: 15%;
  float: left;
}
.field_l_3 {
  width: 15%;
  float: left;
}
.field_l_4 {
  width: 15%;
  float: left;
}
.field_l_5 {
  width: 25%;
  float: left;
}

.nafield_l_1 {
  width: 25%;
  float: left;
}
.nafield_l_2 {
  width: 13%;
  float: left;
}
.nafield_l_3 {
  width: 13%;
  float: left;
}
.nafield_l_4 {
  width: 13%;
  float: left;
}
.nafield_l_5 {
  width: 18%;
  float: left;
}
.nafield_l_6 {
  width: 18%;
  float: left;
}

.nafield_1 {
  width: 10%;
  float: left; 
}
.nafield_2 {
  width: 23%;
  float: left; 
}
.nafield_3 {
  width: 12%;
  float: left; 
}
.nafield_4 {
  width: 10%;
  float: left; 
}
.nafield_8 {
  width: 10%;
  float: left; 
}
.nafield_5 {
  width: 10%;
  float: left; 
}
.nafield_6 {
  width: 10%;
  float: left; 
}
.nafield_7 {
  width: 15%;
  float: left; 
}
.ccfield_1 {
  width: 23%;
  float: left; 
}
.ccfield_2 {
  width: 13%;
  float: left; 
}
.ccfield_3 {
  width: 11%;
  float: left; 
}
.ccfield_4 {
  width: 14%;
  float: left; 
}
.ccfield_5 {
  width: 13%;
  float: left; 
}
.ccfield_6 {
  width: 12%;
  float: left; 
}
.ccfield_7 {
  width: 14%;
  float: left; 
}

</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_billing_tab.vue